import Vue from 'vue'
import Router from 'vue-router'
import Index from '../views/Index'
import Dns from '../views/Dns'
import Tools from '../views/Tools'
import Books from '../views/Books'
import Map from '../views/Map'
import Children from '../views/Children'
import Student from '../views/Student'
import Library from '../views/library'
import Holiday from '../views/Holiday'
import Param from '../views/Param'
import Url from '../views/Url'
import Moon from '../views/Moon'
import Sn from '../views/Sn'
import Soul from '../views/Soul'
import Poem from '../views/Poem'
import ZtDept from '../views/ZtDept'
import ZtRole from '../views/ZtRole'
import ZtPrivilege from '../views/ZtPrivilege'
import ZtUser from '../views/ZtUser'
import Salary from '../views/Salary'
import Idiom from '../views/Idiom'
import Hanzi from '../views/Hanzi'
import Xiehouyu from '../views/Xiehouyu'
import Riddle from '../views/Riddle'
import Tangshi from '../views/Tangshi'
import Words from '../views/Words'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/dns',
      name: 'Dns',
      component: Dns
    },
    {
      path: '/tools',
      name: 'Tools',
      // redirect: '/bd/tools/'
      // redirect: 'http://fujzz.bj01.bdysite.com/tools/'
      component: Tools
    },
    {
      path: '/books',
      name: 'Books',
      component: Books
    },
    {
      path: '/idiom',
      name: 'Idiom',
      component: Idiom
    },
    {
      path: '/hanzi',
      name: 'Hanzi',
      component: Hanzi
    },
    {
      path: '/tangshi',
      name: 'Tangshi',
      component: Tangshi
    },
    {
      path: '/xiehouyu',
      name: 'Xiehouyu',
      component: Xiehouyu
    },
    {
      path: '/riddle',
      name: 'Riddle',
      component: Riddle
    },
    {
      path: '/words',
      name: 'Words',
      component: Words
    },
    {
      path: '/map',
      name: 'Map',
      component: Map
    },
    {
      path: '/children',
      name: 'Children',
      component: Children
    },
    {
      path: '/student',
      name: 'Student',
      component: Student
    },
    {
      path: '/library',
      name: 'Library',
      component: Library
    },
    {
      path: '/salary',
      name: 'Salary',
      component: Salary
    },
    {
      path: '/holiday',
      name: 'Holiday',
      component: Holiday
    },
    {
      path: '/param',
      name: 'Param',
      component: Param
    },
    {
      path: '/url',
      name: 'Url',
      component: Url
    },
    {
      path: '/moon',
      name: 'Moon',
      component: Moon
    },
    {
      path: '/sn',
      name: 'Sn',
      component: Sn
    },
    {
      path: '/soul',
      name: 'Soul',
      component: Soul
    },
    {
      path: '/poem',
      name: 'Poem',
      component: Poem
    },
    {
      path: '/zt_dept',
      name: 'ZtDept',
      component: ZtDept
    },
    {
      path: '/zt_role',
      name: 'ZtRole',
      component: ZtRole
    },
    {
      path: '/zt_privilege',
      name: 'ZtPrivilege',
      component: ZtPrivilege
    },
    {
      path: '/zt_user',
      name: 'ZtUser',
      component: ZtUser
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js